import React from 'react';
import { ClosePopupButton, Popup, PopupText } from 'features/nekst-widgets';
import { ConnectionProfile, ProjectType } from 'nekst-api';
import { Button, ButtonSize } from 'ui-builder';
import { useApplicationSettingsNavigationContextRequired } from '../../../Settings';

export default function SetupNotCompletedPopup(props: {
  profile: ConnectionProfile,
  projectType: ProjectType,
}) {
  const profile = props.profile;

  const applicationSettingsNavigatorContext = useApplicationSettingsNavigationContextRequired();

  if (profile) {
    return (
      <Popup
        title="Create a Deal In Follow Up Boss"
        content={(
        <PopupText>
          To create a Deal in Followup Boss, please finalize the setup in Settings, by selecting a "Pipeline" and "Stage" for each type of Nekst transaction.
        </PopupText>
        )}
        buttons={(
          <>
            <Button
              text="Go to Settings"
              onClick={() => {
                applicationSettingsNavigatorContext.openApplicationSettings(props.projectType);
              }}
              size={ButtonSize.BIG}
            />
            <ClosePopupButton />
          </>
          )}
      />
    );
  } else {
    return null;
  }
}
